export interface Notification {
  icon: string | null;
  type: string;
  classes: string | undefined | null;
  message: string | undefined | null;
  date: Date;
  id?: string;
  isRead?: boolean;
  page?: string;
  pageUrl?: string;
  module?: string;
  userAgent?: string;
  browser?: string;
  requestParameters?: string;
  dateTimeAccessed?: Date;
  httpMethod?: string;
  dateTimeExited?: Date | null;
  monitoringType?: number;
  tabSessionId?: string;
  notificationType?: string | null;
  createdon?: Date;
  isTimeOut?: boolean;
  appNotifyId?: string;
  duration?: string;
  serverity?: NotificationSeverity;
}

export enum NotificationSeverity {
  NORMAL,
  ALERT,
  HIGH_ALERT,
}

export enum NotificationSeenStatus {
  READ,
  UNREAD,
}
